import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const PreviousButton = ({ onClick, children }) => (
  <Button type="link" className="investor-profile__back-button" onClick={onClick}>
    <ArrowLeftOutlined /> <u className="investor-profile__back-button-label">{children}</u>
  </Button>
);

PreviousButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default PreviousButton;
